import React from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { PATH } from '../../../constants/path';
import { PAGE_DIRECTORY } from '../../../services/filter/constants';
import { cashbackDirectoryRoutes } from '../../../routes/directory';

import { clearFilter, clearSort, sortPartnerOnOrder } from '../../../services/filter/actions';

import { mapRoutes } from '../../../utils/routeUtils';

import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

class CashbackDirectoryPage extends React.Component {
    componentDidMount() {
        this.props.sortPartnerOnOrder(PAGE_DIRECTORY);
    }

    componentWillUnmount() {
        this.props.clearFilter(PAGE_DIRECTORY);
        this.props.clearSort(PAGE_DIRECTORY);
    }

    render() {
        const { i18nPage } = this.props;
        return (
            <div>
                <LocalizedBreadcrumbItem to={PATH.CASHBACK_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <Switch>{mapRoutes(cashbackDirectoryRoutes)}</Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.DIRECTORY.CASHBACK
    };
};

const mapDispatchToProps = {
    clearFilter,
    clearSort,
    sortPartnerOnOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(CashbackDirectoryPage);



// WEBPACK FOOTER //
// ./src/components/pages/directory/CashbackDirectoryPage.js